import { defineComponent as d, computed as u, createBlock as s, openBlock as r, Transition as m, withCtx as a, createCommentVNode as p, resolveDynamicComponent as _, mergeProps as f, toHandlers as v, createSlots as x, renderList as M, createElementVNode as L } from "vue";
import C from "./useModals.js";
import { _ as h } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const k = ["innerHTML"], H = /* @__PURE__ */ d({
  __name: "Modals",
  setup(T) {
    const t = C(), e = u(() => t.current);
    function c(n) {
      var o;
      return (o = n.options) != null && o.disableDefaultListeners ? {} : {
        dismiss: () => t.close({ index: 0 }),
        close: () => t.close({ index: 0 }),
        cancel: () => t.close({ index: 0 })
      };
    }
    return (n, o) => (r(), s(m, {
      name: "modals",
      mode: "out-in"
    }, {
      default: a(() => [
        e.value ? (r(), s(_(e.value.component), f({ key: 0 }, e.value.attributes, { "is-open": !0 }, v(c(e.value))), x({ _: 2 }, [
          M(e.value.slots, (l, i) => ({
            name: i,
            fn: a(() => [
              L("div", { innerHTML: l }, null, 8, k)
            ])
          }))
        ]), 1040)) : p("", !0)
      ]),
      _: 1
    }));
  }
}), B = /* @__PURE__ */ h(H, [["__scopeId", "data-v-cf8ad226"]]);
export {
  B as default
};
//# sourceMappingURL=Modals.js.map
